import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DestroyBase } from "../ng-destroy-base";

/**
 * Handles the steps manager component
 */
@Component({
  selector: 'steps-manager',
  templateUrl: './steps.manager.component.html',
  styleUrls: ['./steps.manager.component.css']
})
export class StepsManagerComponent extends DestroyBase implements OnInit {
  /**
   * The number of steps
   */
  @Input() stepsCount: number;

  /**
   * Displayes the close button to be able to close the steps manager
   */
  @Input() displayCloseButton: boolean;

  /**
   * The current step number
   */
  @Input() currentStep: number;

  /**
   * Uses standard colors
   */
  @Input() set useStandardColors(value: any) {
    if (value) {
      this.isStandardColors = value;
    }
  }

  /**
   * Emits when the close button is clicked
   */
  @Output() onCloseClicked: EventEmitter<void> = new EventEmitter();

  /**
  * This array stores the steps for the process
  */
  steps = [];

  /**
  * This variable stores the CSS class for the steps element
  */
  stepsClass = '';

  /**
  * This variable indicates whether standard colors are being used
  */
  isStandardColors = false;

  /**
   * Initializes a new instance of the StepsManagerComponent class.
   */
  ngOnInit(): void {
    /**
     * Initializes the steps array with sequential numbers from 0 to stepsCount
     */
    this.steps = [...Array(this.stepsCount + 1).keys()];

    /**
     * Removes the first element from the steps array to remove the zero value
     */
    this.steps.shift();

    /**
     * Sets the CSS class for the steps element based on the stepsCount
     */
    this.stepsClass = `steps-${this.stepsCount}`;
  }

  /**
   * Handles the close button click
   */
  closeClicked(): void {
    this.onCloseClicked.emit();
  }
}
